/*
	JS for the minimal.twig template
*/


// Modernizr-style check for flexbox `gap` support
import { supportsFlexGap } from "./helpers/BrowserCompat";

if ( supportsFlexGap() ) {
	document.documentElement.classList.add("flexbox-gap");
} else {
	document.documentElement.classList.add("no-flexbox-gap");
}